/**
 * [SimpleHitTestSupport]{@link enyo-canvas.SimpleHitTestSupport} is a mixin for
 * [CanvasControl]{@link enyo-canvas.CanvasControl} that implements a simple
 * hit-test based on [CanvasBounds]{@link enyo-canvas.CanvasBounds} or
 * [CssBounds]{@link enyo-canvas.CssBounds}.
 *
 * @mixin enyo-canvas.SimpleHitTestSupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-canvas.SimpleHitTestSupport",

    /**
     * Figure out if the supplied coordinates in css pixels relative to the
     * top-left corner of the canvas tag fall within the
     * [CssBounds]{@link enyo-canvas.CssBounds} of the control.
     *
     * @param    {number}   x  The x-coordinate
     * @param    {number}   y  The y-coordinate
     * @return   {boolean}  Whether the input coordinates hit the Control
     * @memberof enyo-canvas.SimpleHitTestSupport
     * @method
     * @public
     */
    cssHitTest: function(x, y) {
        var bounds = this.getCssBounds();

        return (x > bounds.left
            && y > bounds.top
            && x < bounds.left + bounds.width
            && y < bounds.top + bounds.height) ? true : false;
    },

    /**
     * Figure out if the supplied coordinates in css space fall within the
     * [CanvasBounds]{@link enyo-canvas.CanvasBounds} of the control.
     *
     * @param    {number}   x  The x-coordinate
     * @param    {number}   y  The y-coordinate
     * @return   {boolean}  Whether the input coordinates hit the Control
     * @memberof enyo-canvas.SimpleHitTestSupport
     * @method
     * @public
     */
    canvasHitTest: function(x, y) {
        var bounds = this.getCanvasBounds();

        return (x > bounds.x
            && y > bounds.y
            && x < bounds.x + bounds.width
            && y < bounds.y + bounds.height) ? true : false;
    }

};
